import * as React from 'react';
import { useEffect } from 'react';

import Retracked from 'js/lib/retracked';

import { useTracker } from '@coursera/event-pulse/react';

import type { ApiError } from 'bundles/enroll-common/utils/errorUtils';
import { getMessage } from 'bundles/enroll-common/utils/errorUtils';
import Modal from 'bundles/phoenix/components/Modal';

import 'css!./__styles__/EnrollErrorModal';

type EventingProduct =
  | { id: string; type: 's12n' }
  | { id: string; type: 'course' }
  | { id: string; type: 'cplus' }
  | { id: string; type: 'project' };

const EnrollErrorModal = ({
  onClose,
  error,
  isFinancialAid = false,
  isFreeEnroll = false,
  messageOverride,
  courseId,
  s12nId,
  isSpecialization = false,
  eventingProduct,
}: {
  onClose: () => void;
  error?: ApiError;
  isFinancialAid?: boolean;
  isFreeEnroll?: boolean;
  messageOverride?: string;
  courseId?: string;
  s12nId?: string;
  isSpecialization?: boolean;
  eventingProduct?: EventingProduct;
}) => {
  const track = useTracker();

  useEffect(() => {
    const CONTEXT_DATA = {
      namespace: {
        app: 'enroll',
        page: 'enroll_modal',
      },
    };
    let eventingV3Product: EventingProduct | undefined;
    if (eventingProduct) {
      eventingV3Product = eventingProduct;
    } else if (courseId && !isSpecialization) {
      eventingV3Product = { id: courseId, type: 'course' };
    } else if (s12nId) {
      eventingV3Product = { id: s12nId, type: 's12n' };
    }

    Retracked.trackComponent(
      CONTEXT_DATA,
      eventingV3Product ? { product: eventingV3Product } : {},
      'error_modal',
      'view'
    );

    track('view_modal', {
      modal: { name: 'enroll_error' },
      ...(eventingV3Product ? { product: eventingV3Product } : {}),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const message = messageOverride || getMessage(error, isFinancialAid, isFreeEnroll);
  return (
    <Modal modalName="EnrollErrorModal" className="rc-EnrollErrorModal" handleClose={onClose} allowClose={true}>
      <p className="m-t-1s m-b-0">{message}</p>
    </Modal>
  );
};

export default EnrollErrorModal;
